"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnDropPiece = void 0;
const react_redux_1 = require("react-redux");
const ui_1 = require("~/store/game/ui");
const board_1 = require("@creature-chess/board");
const resolvePiecePlacement_1 = require("../resolvePiecePlacement");
const useOnDropPiece = (board, bench) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    return ({ id, location }) => {
        const toY = location.locationType === "board" ? location.y : 0;
        const target = {
            type: location.locationType,
            location: (0, board_1.packPosition)(location.x, toY),
        };
        const result = (0, resolvePiecePlacement_1.resolvePiecePlacement)(id, target, board, bench);
        if (result.kind !== "noop") {
            dispatch(result.action);
        }
        dispatch((0, ui_1.clearSelectedPiece)());
    };
};
exports.useOnDropPiece = useOnDropPiece;
